var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-top": "10px" }
        },
        [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "50px",
                    "label-position": "left"
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("common.btn.query") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "310px" },
                        attrs: {
                          no: "queryInput",
                          placeholder: _vm.$t("common.tips.fuzzySearch")
                        },
                        model: {
                          value: _vm.filter.likeName,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "likeName", $$v)
                          },
                          expression: "filter.likeName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "triggers" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "query", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.filter.pageNum = 1
                      _vm.toQuery()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "new", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "edit", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showEditDialog(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "delete", size: "mini", type: "danger" },
                  on: { click: _vm.remove }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-grid" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              no: "grid",
              "config-module": "250315",
              "grid-params": _vm.girdParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-pagination" },
        [
          _c("cargo-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0"
              }
            ],
            attrs: {
              no: "pagination",
              total: _vm.total,
              page: _vm.filter.pageNum,
              limit: _vm.filter.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.filter, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.filter, "pageSize", $event)
              },
              pagination: _vm.toQuery
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.editDialog.visible,
            title: _vm.editDialog.title,
            width: "800px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.editDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { display: "flex" },
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_TerminalName"),
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "140px" },
                            attrs: { no: "warehouseName" },
                            model: {
                              value: _vm.editDialog.form.warehouseName,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "warehouseName",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.warehouseName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_TerminalCode"),
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "140px" },
                            attrs: { no: "warehouseCode" },
                            model: {
                              value: _vm.editDialog.form.warehouseCode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "warehouseCode",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.warehouseCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_AirportCode"),
                            required: ""
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "140px" },
                            attrs: {
                              no: "airportCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "custom-label": function(item) {
                                return "" + item.code
                              },
                              "filter-tag-names": ["code", "englishName"],
                              filterable: "",
                              "tag-name": "code",
                              "tag-value": "code",
                              "show-custom-label-in-option": true,
                              "default-value": _vm.editDialog.form.airportCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.editDialog.form.airportCode = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      staticStyle: { display: "flex" },
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_OrderType"),
                            required: ""
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "140px" },
                              attrs: { no: "orderType" },
                              model: {
                                value: _vm.editDialog.form.orderType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.editDialog.form,
                                    "orderType",
                                    $$v
                                  )
                                },
                                expression: "editDialog.form.orderType"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "AE", value: "AE" }
                              }),
                              _c("el-option", {
                                attrs: { label: "AI", value: "AI" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_SecurityCheckMachineWidthLimit"
                            ),
                            required: ""
                          }
                        },
                        [
                          _c("auto-number-input", {
                            staticStyle: { width: "140px" },
                            attrs: {
                              no: "securityMachineWidth",
                              precision: 0,
                              "enforce-min": true,
                              min: 0
                            },
                            model: {
                              value: _vm.editDialog.form.securityMachineWidth,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "securityMachineWidth",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.securityMachineWidth"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_SecurityCheckMachineHeightLimit"
                            ),
                            required: ""
                          }
                        },
                        [
                          _c("auto-number-input", {
                            staticStyle: { width: "140px" },
                            attrs: {
                              no: "securityMachineHeight",
                              precision: 0,
                              "enforce-min": true,
                              min: 0
                            },
                            model: {
                              value: _vm.editDialog.form.securityMachineHeight,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "securityMachineHeight",
                                  $$v
                                )
                              },
                              expression:
                                "editDialog.form.securityMachineHeight"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      staticStyle: { display: "flex" },
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_TerminalAddress")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "140px" },
                            attrs: { no: "warehouseAddress" },
                            model: {
                              value: _vm.editDialog.form.warehouseAddress,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "warehouseAddress",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.warehouseAddress"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_CustomsCode") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "140px" },
                            attrs: { no: "customsCode" },
                            model: {
                              value: _vm.editDialog.form.customsCode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "customsCode",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.customsCode"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_RemarksInfo") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "140px" },
                            attrs: { no: "remarks" },
                            model: {
                              value: _vm.editDialog.form.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.editDialog.form, "remarks", $$v)
                              },
                              expression: "editDialog.form.remarks"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      staticStyle: { display: "flex" },
                      attrs: {
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_RecipientContact")
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "140px" },
                            attrs: { no: "receiverContact" },
                            model: {
                              value: _vm.editDialog.form.receiverContact,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "receiverContact",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.receiverContact"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_RecipientContactPhone"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "140px" },
                            attrs: { no: "receiverPhone" },
                            model: {
                              value: _vm.editDialog.form.receiverPhone,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.editDialog.form,
                                  "receiverPhone",
                                  $$v
                                )
                              },
                              expression: "editDialog.form.receiverPhone"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_DeliveryMap") }
                        },
                        [
                          _c(
                            "u",
                            {
                              staticStyle: {
                                color: "#46a6ff",
                                cursor: "pointer"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.uploadAttachment(
                                    _vm.editDialog.form.uuid
                                  )
                                }
                              }
                            },
                            [_vm._v(_vm._s(this.$t("Partners.uploadFile")))]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%" },
            attrs: {
              no: "grid",
              "grid-options": _vm.edit.editGridOptions,
              "column-defs": _vm.edit.editColumnDefs,
              "row-data": _vm.edit.editRowData
            },
            on: {
              gridReady: function(params) {
                _vm.edit.editGridApi = params.api
              }
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.editDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.cameraDialog.visible,
            title: _vm.cameraDialog.title,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.cameraDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "80px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_MonitoringInterface")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { no: "cameraInterfaceType" },
                              model: {
                                value:
                                  _vm.cameraDialog.form.cameraInterfaceType,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cameraDialog.form,
                                    "cameraInterfaceType",
                                    $$v
                                  )
                                },
                                expression:
                                  "cameraDialog.form.cameraInterfaceType"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_MonitoringInterface1"
                                  ),
                                  value: "1"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "AppKey" } },
                        [
                          _c("el-input", {
                            attrs: { no: "cameraAppKey" },
                            model: {
                              value: _vm.cameraDialog.form.cameraAppKey,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.cameraDialog.form,
                                  "cameraAppKey",
                                  $$v
                                )
                              },
                              expression: "cameraDialog.form.cameraAppKey"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "80px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_DeviceNumber")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "cameraDeviceNumber" },
                            model: {
                              value: _vm.cameraDialog.form.cameraDeviceNumber,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.cameraDialog.form,
                                  "cameraDeviceNumber",
                                  $$v
                                )
                              },
                              expression: "cameraDialog.form.cameraDeviceNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Secret" } },
                        [
                          _c("el-input", {
                            attrs: { no: "cameraSecret" },
                            model: {
                              value: _vm.cameraDialog.form.cameraSecret,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.cameraDialog.form,
                                  "cameraSecret",
                                  $$v
                                )
                              },
                              expression: "cameraDialog.form.cameraSecret"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%" },
            attrs: {
              no: "cameraGrid",
              "grid-options": _vm.cameraC.gridOptions,
              "column-defs": _vm.cameraC.columnDefs,
              "row-data": _vm.cameraC.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.cameraC.gridApi = params.api
              }
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.cameraSave }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-file-upload-dialog", {
        attrs: {
          visible: _vm.fileUpload.visible,
          title: _vm.fileUpload.title,
          "document-category": _vm.fileUpload.documentCategory,
          "business-id": _vm.fileUpload.businessId,
          "show-file-category": _vm.fileUpload.showFileCategory,
          lob: _vm.fileUpload.lob,
          parameters: _vm.fileUpload.parameters
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.fileUpload, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }